import { Clapperboard, LucideProps } from "lucide-react";
import { forwardRef } from "react";

export const ImageToVideoIcon = forwardRef(function ImageToVideoIcon(
  props: Omit<LucideProps, "ref"> & React.RefAttributes<SVGSVGElement>,
  forwardedRef: React.LegacyRef<SVGSVGElement>,
) {
  return <Clapperboard {...props} ref={forwardedRef} />;
});
